module.exports = __webpack_public_path__ + "static/camera.aa5496dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/camera.svg
// module id = 228
// module chunks = 35783957827783 95715928098905 172322841747965